<div class="b-a b-col-42 p-t-4 p-b-4 m-t-6 p-l-6 p-l-3-s p-l-3-m p-r-6 p-r-3-m p-r-3-s flex flex-middle _inputWrapper">
    <i class="_icon icon-search"
       aria-hidden="true"></i>
    <input type="text"
           class="flex-grow flex-grow p2 col-1 _input"
           [placeholder]="placeholder()"
           [ngModel]="query()"
           (ngModelChange)="query.set($event)"
           (focus)="onFocus()"
           (blur)="onBlur()"
           (keydown.enter)="selectFirstOption()">

    <i class="_icon icon-close cursor-pointer"
       [class._hidden]="!isOpen()"
       (click)="handleClose()"
       aria-hidden="true"></i>
</div>


@if (isOpen()) {
<div class="_options custom-scrollbar b-col-42 b-l b-r">
    @if (filteredOptions().length) {
    @for (option of filteredOptions(); track option.value) {
    <div class="p-l-3 p-r-3 p-t-4 p-b-4 b-b b-col-42 cursor-pointer"
         (click)="selectOption(option)"
         [ngClass]="value === option.value ? 's2 bg-col-5 col-11' : 'p2 bg-col-w col-1'">
        {{ option.label }}
    </div>
    }
    } @else {
    <div class="p-l-3 p-r-3 p-t-4 p-b-4 p2 b-col-42 bg-col-w col-12 b-b">
        No results found
    </div>
    }
</div>
}